import React, { useState } from "react";
import { leaf } from "../../assets";
import OTPInput, { ResendOTP } from "otp-input-react";
import { CgSpinner } from "react-icons/cg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { authentication } from "../../Auth/api_firebase";
import toast, { Toaster } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";

const AuthPage = () => {
  const [otp, setOpt] = useState("");
  const [num, setNum] = useState("");
  const [username, setUsername] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);

  const navigate = useNavigate();

  const onCaptchaVerify = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        authentication,
        "recaptcha-container",
        {
          size: "invisible",
          callback: () => {},
          "expired-callback": () => {},
        }
      );
    }
  };

  const onSignup = () => {
    setLoading(true);
    onCaptchaVerify();

    setUserInfo({
      username: username,
      phone: num,
    });

    const appVerifier = window.recaptchaVerifier;

    const formatNum = "+" + num;

    signInWithPhoneNumber(authentication, formatNum, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        setLoading(false);
        setShowOTP(true);
        toast.success("OTP sended successfully!");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const onOTPVerify = () => {
    setLoading(true);
    window.confirmationResult
      .confirm(otp)
      .then((result) => {
        navigate("/");
        //post on DB
        fetch("https://laser-treat-server.onrender.com/auth/user/sign-in", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userInfo),
        });
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        window.location.reload(false);
        toast.success("Login Successfull!");
      })
      .catch((error) => {
        // console.log(error);
        setLoading(false);
      });
  };

  console.log(userInfo);
  return (
    <div id="loginPage">
      <Toaster toastOptions={{ duration: 4000 }} />
      <div className="gradient"></div>
      <div id="recaptcha-container"></div>
      {showOTP ? (
        <section className="otp">
          <div className="title">
            <img src={leaf} alt="" width={50} />
            <h2>Dear {username}</h2>
          </div>
          <div className="main">
            <label htmlFor="">Enter your OTP for the number +{num}</label>
            <OTPInput
              value={otp}
              onChange={setOpt}
              autoFocus
              OTPLength={6}
              otpType="number"
              disabled={false}
            ></OTPInput>
            <button onClick={onOTPVerify}>
              {loading && (
                <CgSpinner
                  className={loading ? "spinner animate" : "spinner"}
                />
              )}
              <span>Verify OTP</span>
            </button>
          </div>

          <small>
            Wrong Number?{" "}
            <span onClick={() => setShowOTP(false)}>Use different number</span>
          </small>
        </section>
      ) : (
        <section className="login-info">
          <div className="title">
            <img src={leaf} alt="" width={50} />
            <h2>Welcome to Laser Treat</h2>
          </div>
          <div className="main">
            <div className="inp-grp">
              <label htmlFor="">Enter your Name</label>
              <input
                type="text"
                placeholder="Name"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
                id="username"
              />
            </div>
            <div className="inp-grp">
              <label htmlFor="">Enter your Phone Number</label>
              <PhoneInput
                country={"bd"}
                type="number"
                placeholder="Number"
                value={num}
                onChange={setNum}
                name="usernum"
              />
            </div>

            <button className="submitBtn" onClick={onSignup}>
              {loading && (
                <CgSpinner
                  className={loading ? "spinner animate" : "spinner"}
                />
              )}
              <span>Login</span>
            </button>
          </div>
        </section>
      )}
    </div>
  );
};

export default AuthPage;
